export default __webpack_public_path__ + "static/media/image.xiges-solutions.78397be9.png";